/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { VFlow } from 'bold-ui'
import { ProcedimentoOdontoSelectModel } from 'components/form/field/select/ProcedimentoOdontoSelectField'
import { MetaArray } from 'util/metaPath'
import { EditableList, RowType, useEditableListField } from 'view/atendimentos/detail/components/EditableList'

import OutrosForm, { OutrosFormModel } from './OutrosForm'
import OutrosTable from './OutrosTable'

export interface OutrosFieldModel extends RowType {
  local: string
  procedimentos: ProcedimentoOdontoSelectModel[]
  observacao?: string
}

export interface OutrosFieldProps {
  name: MetaArray<OutrosFieldModel>
  cidadaoDataNascimento: LocalDate
}

export const trimOutrosObservacao = (values: OutrosFormModel) =>
  ({
    ...values,
    observacao: values?.observacao?.trim() ? values.observacao : undefined,
  } as OutrosFormModel)

export default function OutrosField(props: OutrosFieldProps) {
  const { name, cidadaoDataNascimento } = props

  const {
    handleSubmit,
    handleRowChanged,
    removeItem,
    input: { value },
  } = useEditableListField<OutrosFieldModel>({
    name,
  })

  return (
    <EditableList>
      <VFlow vSpacing={0}>
        <div
          css={css`
            padding: 1rem;
          `}
        >
          <OutrosForm cidadaoDataNascimento={cidadaoDataNascimento} onSubmit={handleSubmit} />
        </div>

        <OutrosTable
          items={value}
          cidadaoDataNascimento={cidadaoDataNascimento}
          updateItem={handleRowChanged}
          removeItem={removeItem}
        />
      </VFlow>
    </EditableList>
  )
}
